import { useFormik } from 'formik'
import validationSchema from './validation-schema'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { FiEye, FiEyeOff } from 'react-icons/fi'
import { Input, Typography, Button, Alert } from '@material-tailwind/react'
import { userServices } from '@/services'

export const LoginForm = () => {
  const navigate = useNavigate()
  const [signInError, setSignInError] = useState(null)
  const [password, setPassword] = useState({
    icon: FiEyeOff,
    type: 'password'
  })


  const handleLogin = async (values) => {
    try {
      const response = await userServices.signIn({ body: { user: values } });
    } catch ({ response }) {
      setSignInError(response.data.error);
    }
  };

  const handlePasswordType = () => {
    if (password.type === 'password') {
      setPassword({
        icon: FiEye,
        type: 'text'
      })
      return
    }

    setPassword({
      icon: FiEyeOff,
      type: 'password'
    })
  }

  const { handleBlur, handleSubmit, handleChange, values, errors, touched } =
    useFormik({
      initialValues: { email: '', password: '' },
      validationSchema,
      onSubmit: handleLogin
    })

  return (
    <div className='w-full flex flex-col gap-10'>
      <form onSubmit={handleSubmit}>
        <section className='flex flex-col gap-6'>
          <div>
            <Input
              name='email'
              label='Correo electrónico'
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              error={Boolean(touched.email && errors.email)}
            />

            {touched.email && errors.email && (
              <Typography
                variant='small'
                color='red'
                className='mt-2 flex items-center gap-1 font-normal'
              >
                {errors.email}
              </Typography>
            )}
          </div>

          <div>
            <div className='relative w-full'>
              <Button
                onClick={handlePasswordType}
                color='gray'
                variant='text'
                className='!absolute h-full right-0 flex items-center pr-3.5 z-10 !w-min !p-3'
              >
                {password.icon({ size: '1rem' })}
              </Button>

              <Input
                name='password'
                label='Contraseña'
                type={password.type}
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                error={Boolean(touched.password && errors.password)}
              />
            </div>
            {touched.password && errors.password && (
              <Typography
                variant='small'
                color='red'
                className='mt-2 flex items-center gap-1 font-normal'
              >
                {errors.password}
              </Typography>
            )}
          </div>

          {signInError && (
            <Alert color='red' variant='outlined' className='bg-red-50'>
              {signInError}
            </Alert>
          )}

          <Button className='btn btn-primary' type='submit' size='lg'>
            Continuar
          </Button>

          <Button
            size='lg'
            variant='text'
            onClick={() => navigate('/recovery_password')}
          >
            Recuperar contraseña
          </Button>
        </section>
      </form>
    </div>
  )
}
